import { useFormik } from "formik";
import appActions from "../../../appActions";
import { useDispatch } from "react-redux";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { isPermissionCodeValid } from "../../../utils/mics";

const CleanUpLogs = ({ pageId }) => {
    
    const readAccess = isPermissionCodeValid(`${pageId}-R`);
    // const writeAccess = isPermissionCodeValid(`${pageId}-W`);
    // const deleteAccess = isPermissionCodeValid(`${pageId}-D`);

    const dispatch = useDispatch();

    const formik = useFormik({
        initialValues: {
            //dateFrom: '',
            filePath: '',
        },
        onSubmit: (values) => {
            const data = {
                ...values,
                //dateFrom: values.dateFrom ? moment(values.dateFrom).format('YYYY-MM-DD') : '',
            };

            dispatch(appActions.EXPORTLOGS_CLEAN_UP_LOG_REQUEST(data));
        },
    });

    const handleClear = () => {
        formik.resetForm();
    };

    const renderHeader = () => (
        <div className="col-12">
            <h1 className="page-header flex"> Logs Cleanup </h1>
        </div>
    );

    const handleChange = (e) => {
        formik.handleChange(e);
    }


    const renderList = () => (
        <>
            <div className="grid px-4 align-items-center my-2">{renderHeader()}</div>

            <div className="bg-white mx-4 pv-20 ph-20 br-6 shadow-white">
                <>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="grid p-2">
                            <div className="p-fluid formgrid grid w-full">
                                <div className="field col-12 md:col-3">
                                    <label htmlFor="filePath">Log Directory Path</label>
                                    <InputText
                                        id="filePath"
                                        name="filePath"
                                        type="text"
                                        value={formik.values.filePath}
                                        onChange={handleChange}
                                    />
                                </div>  
                            </div>
                        </div>

                        <div className="grid px-2 py-4 flex-row-reverse gap-10">
                            {readAccess && <>
                                <Button type="submit" icon="pi pi-search" label="Submit" severity="success" outlined className="p-button-success mr-2" />
                                <Button type="button" icon="pi pi-filter-slash" className='tp' data-pr-tooltip="Reset" label="Reset" severity="secondary" outlined onClick={handleClear} />
                            </>}
                        </div>
                    </form>
                </>
            </div>
        </>
    );

    return <div className="form_height">{renderList()}</div>;
};

export default CleanUpLogs;